import { put, takeEvery, all } from 'redux-saga/effects';
import { showNotification, englishMessages } from 'admin-on-rest';

export const messages = {
    en: {
        aor: {
			...englishMessages.aor,
			notification: {
	            updated: 'Account updated',
	            created: 'Account created',
	            deleted: 'Account deleted',
			},
		},
	},
};

function success(message) {
	return function* () {
		yield put(showNotification(message));
	}
}

function failure(message) {
	return function* ({ error }) {
    	yield put(showNotification(`Error: ${message}, see console for details`, 'warning'));
    	console.error(error);
	}
}

export default function* accountSagas() {
    yield all([
        takeEvery('ACCOUNT_TRANSMIT_SUCCESS', success('Account transmitted')),
        takeEvery('ACCOUNT_TRANSMIT_FAILURE', failure('Account not transmitted')),
        takeEvery('ACCOUNT_RELEASE_SUCCESS', success('Account released')),
        takeEvery('ACCOUNT_RELEASE_FAILURE', failure('Account not released')),
        takeEvery('ACCOUNT_CONFIRM_TRANSMITTAL_SUCCESS', success('Account transmittal confirmed')),
        takeEvery('ACCOUNT_CONFIRM_TRANSMITTAL_FAILURE', failure('Account transmittal not confirmed')),
        takeEvery('ACCOUNT_BOOK_SUCCESS', success('Account booked')),
        takeEvery('ACCOUNT_BOOK_FAILURE', failure('Account not booked')),
        takeEvery('ACCOUNT_FOR_COLLECTION_SUCCESS', success('Account set for collection')),
        takeEvery('ACCOUNT_FOR_COLLECTION_FAILURE', failure('Account not set for collection')),
        takeEvery('ACCOUNT_PROCEEDS_COLLECTED_SUCCESS', success('Account proceeds collected')),
        takeEvery('ACCOUNT_PROCEEDS_COLLECTED_FAILURE', failure('Account proceeds not collected')),
        takeEvery('ACCOUNT_DI_COLLECTED_SUCCESS', success('Account DI collected')),
        takeEvery('ACCOUNT_DI_COLLECTED_FAILURE', failure('Account DI not collected')),
        takeEvery('ACCOUNT_SUBMIT_OR_CR_SUCCESS', success('OR/CR submitted')),
        takeEvery('ACCOUNT_SUBMIT_OR_CR_FAILURE', failure('OR/CR not submitted')),
    ]);
}



// WEBPACK FOOTER //
// ./src/accountSagas.js